import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { Combinator } from 'modules/queryBuilder/types';
import { AndIcon, NotIcon, OrIcon } from '../../CombinatorIcons';
import { DEFAULT_COMBINATOR_LABEL } from '../constants';
import { DQBSearchVariant } from '../types';

export const useCombinatorControlOptions = (variant: DQBSearchVariant) => {
  const { t } = useTranslation();
  return [
    {
      name: t(DEFAULT_COMBINATOR_LABEL[Combinator.AND]),
      value: Combinator.AND,
      Icon: variant !== DQBSearchVariant.Query ? AndIcon : undefined,
    },
    {
      name: t(DEFAULT_COMBINATOR_LABEL[Combinator.OR]),
      value: Combinator.OR,
      Icon: variant !== DQBSearchVariant.Query ? OrIcon : undefined,
    },
    {
      name: t(DEFAULT_COMBINATOR_LABEL[Combinator.NOT]),
      value: Combinator.NOT,
      Icon: variant !== DQBSearchVariant.Query ? NotIcon : undefined,
    },
  ];
};
